export const REDACTED = '[redacted]';

export const DEFAULT_REDACT_SELECTORS: readonly string[] = [
  'input[type="password"]',
  'input[autocomplete*="password" i]',
  'input[autocomplete*="cc-" i]',
  'input[autocomplete="one-time-code"]',
  'input[name*="ssn" i]',
  'input[name*="card" i]',
  'input[name*="cvv" i]',
  'input[name*="secret" i]',
  'input[name*="token" i]',
  '[data-agent-private]',
  '.agent-no-capture',
];

const PII_PATTERNS: readonly RegExp[] = [
  /[\w.+-]+@[\w-]+\.[\w.-]{2,}/g, // email
  /\+\d[\d\s().-]{7,}\d/g, // international phone
  /\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}\b/g, // grouped phone
  /\b\d{3}-\d{2}-\d{4}\b/g, // US SSN
  /\bey[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}\b/g, // JWT
  /\b(?:AKIA|ASIA)[0-9A-Z]{16}\b/g, // AWS access key id
  /\bsk-[A-Za-z0-9]{16,}\b/g, // provider-style secret key
];

export function isLuhnValid(digits: string): boolean {
  if (digits.length < 13 || digits.length > 19) return false;
  let sum = 0;
  let double = false;
  for (let i = digits.length - 1; i >= 0; i -= 1) {
    let d = digits.charCodeAt(i) - 48;
    if (d < 0 || d > 9) return false;
    if (double) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
    double = !double;
  }
  return sum % 10 === 0;
}

function maskCards(input: string): string {
  return input.replace(/\b(?:\d[ -]?){13,19}\b/g, (match) =>
    isLuhnValid(match.replace(/\D/g, '')) ? REDACTED : match,
  );
}

export function isPrivate(el: Element, extra: readonly string[] = []): boolean {
  for (const selector of [...DEFAULT_REDACT_SELECTORS, ...extra]) {
    try {
      if (el.matches(selector) || el.closest(selector)) return true;
    } catch {
      continue;
    }
  }
  return false;
}

export function redact(value: string): string {
  let out = maskCards(value);
  for (const pattern of PII_PATTERNS) {
    out = out.replace(new RegExp(pattern.source, pattern.flags), REDACTED);
  }
  return out;
}
